import { LinkSvg } from "icons/infograph";
import useTranslation from "next-translate/useTranslation";
import { Edu, Title, EduRow, EduItm } from "./Common.styled";

function Experience() {
  const { t } = useTranslation("common");

  return (
    <Edu>
      <Title>{t("resume.experience")}</Title>

      <EduRow>
        <EduItm>
          <h4>{t("resume.intern-title")}</h4>
          <a href="http://icebergtechnepal.com/" target={"_blank"}>
            <LinkSvg /> Iceberg Technology
          </a>
          <span>{t("resume.intern-duration")}</span>
          <p>{t("resume.intern-desc")}</p>
        </EduItm>
        <EduItm>
          <h4>{t("resume.web-title")}</h4>
          <a href="http://icebergtechnepal.com/" target={"_blank"}>
            <LinkSvg /> Iceberg Technology
          </a>
          <span>{t("resume.web-duration")}</span>
          <p>{t("resume.web-desc")}</p>
        </EduItm>
        <EduItm>
          <h4>{t("resume.react-title")}</h4>
          <a href="http://thesunbi.com/" target={"_blank"}>
            <LinkSvg /> SunBi
          </a>
          <span>{t("resume.react-duration")}</span>
          <p>{t("resume.react-desc")}</p>
        </EduItm>
        <EduItm>
          <h4>{t("resume.next-title")}</h4>
          <a href="https://www.lukuku.co/" target={"_blank"}>
            <LinkSvg /> Lukuku
          </a>
          <span>{t("resume.next-duration")}</span>
          <p>{t("resume.next-desc")}</p>
        </EduItm>
      </EduRow>
    </Edu>
  );
}

export default Experience;
